import React from "react";

import styles from "./styles/Layout.module.scss";
import Inbox from "./Inbox";
import ChatThreads from "./ChatThreads";
import { useChatContext } from "./Context/ChatContext";
import _ from "lodash";

export default function MobileLayout({ user = "", setUser }) {
  const { chatRoom } = useChatContext();
  return (
    <div className={styles.Layout}>
      {!_.isEmpty(chatRoom) ? (
        <Inbox isMobile={true} setUser={setUser} />
      ) : (
        <ChatThreads setUser={setUser} />
      )}
    </div>
  );
}
